export default function D() {
  return (
    <div
      style={{
        width: "90%",
        margin: "auto",
        maxWidth: "1247px",
        borderRadius: "10px",
        backgroundColor: "black",
        marginTop: "80px",
      }}
    >
      <div style={{ width: "95%", margin: "auto" }}>
        <iframe
          width="100%"
          height="480px"
          src="https://www.youtube.com/embed/ItS8X0SjT4s"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
}
